<template>
  <div :class="$style.app">
    <Modals/>
  </div>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex';

import Modals from './components/modals/Modals.vue'

export default {
  name: 'app',
  components: {
    Modals,
  },
  methods: {
    ...mapMutations(['setActiveModal', 'setUser', 'setPrevValues']),
  },
  created() {
    const jwt = localStorage.getItem(process.env.JWT_KEY);
    axios.post(process.env.VUE_APP_SERVER + '/validate_token.php', {jwt})
      .then((r) => {
        this.setPrevValues(r.data.output)
        this.setUser(r.data.user)
      })

    axios.post(process.env.VUE_APP_SERVER + '/update.php', {
      email: 'andrea.delrisco@gmail.com',
      output1: 1,
      output2: 2,
      output3: 1
    }).then(console.log)
  }
}
</script>

<style lang="scss" module>
.app {
  display: block;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  * { box-sizing: border-box; }

  input:focus {
    outline: 0;
  }
  a:empty,
  ul:empty,
  dl:empty,
  div:empty,
  section:empty,
  article:empty,
  p:empty,
  h1:empty,
  h2:empty,
  h3:empty,
  h4:empty,
  h5:empty,
  h6:empty {
    display: inherit;
  }

}
</style>
